import { __assign } from 'tslib';
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { BaseCheckmark } from '../base-checkmark/Component.js';

var styles = {"option":"select__option_1rbq3","disabled":"select__disabled_1rbq3","checkmarkBefore":"select__checkmarkBefore_1rbq3","mobile":"select__mobile_1rbq3","checkmarkAfter":"select__checkmarkAfter_1rbq3","textContent":"select__textContent_1rbq3","selected":"select__selected_1rbq3","highlighted":"select__highlighted_1rbq3","checkmarkBeforeContent":"select__checkmarkBeforeContent_1rbq3","checkmarkAfterContent":"select__checkmarkAfterContent_1rbq3","content":"select__content_1rbq3"};
require('./index.css')

var BaseOption = function (_a) {
    var _b;
    var className = _a.className, option = _a.option, children = _a.children, selected = _a.selected, highlighted = _a.highlighted, disabled = _a.disabled, multiple = _a.multiple, _c = _a.Checkmark, Checkmark = _c === void 0 ? BaseCheckmark : _c, _d = _a.checkmarkPosition, checkmarkPosition = _d === void 0 ? multiple ? 'before' : 'after' : _d, _e = _a.align, align = _e === void 0 ? 'center' : _e, innerProps = _a.innerProps, dataTestId = _a.dataTestId, _f = _a.mobile, mobile = _f === void 0 ? false : _f;
    var content = children || option.content || option.key;
    var _g = option.showCheckMark, showCheckMark = _g === void 0 ? true : _g;
    var isTextContent = !isValidElement(content);
    var renderCheckmark = function () {
        var _a;
        if (Checkmark && showCheckMark) {
            return (React.createElement(Checkmark, { className: cn((_a = {},
                    _a[styles.checkmarkBeforeContent] = checkmarkPosition === 'before',
                    _a[styles.checkmarkAfterContent] = checkmarkPosition === 'after',
                    _a)), disabled: disabled, selected: selected, multiple: multiple, align: align }));
        }
        return null;
    };
    return (React.createElement("div", __assign({}, innerProps, { className: cn(styles.option, className, (_b = {},
            _b[styles.highlighted] = !mobile && highlighted,
            _b[styles.selected] = selected,
            _b[styles.disabled] = disabled,
            _b[styles.textContent] = isTextContent,
            _b[styles.mobile] = mobile,
            _b[styles.checkmarkAfter] = !isTextContent && checkmarkPosition === 'after',
            _b[styles.checkmarkBefore] = !isTextContent && checkmarkPosition === 'before',
            _b)), "data-test-id": dataTestId }),
        checkmarkPosition === 'before' && renderCheckmark(),
        React.createElement("div", { className: cn(styles.content) }, content),
        checkmarkPosition === 'after' && renderCheckmark()));
};

export { BaseOption };
